import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="text-lg font-heading font-bold text-background-50">Kakobuy Finds</span>
              <span className="w-2 h-2 rounded-full bg-accent-400"></span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              An educational resource helping users understand product spreadsheets, shopping research, and online purchasing methods. We do not guarantee product availability or prices. Always verify before purchasing.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-400 mb-4">Categories</h4>
            <div className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-background-200 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-400 mb-4">More Categories</h4>
            <div className="space-y-2">
              {categories.slice(7).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-background-200 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-400 mb-4">Resources</h4>
            <div className="space-y-2">
              <Link to="/kakobuy-spreadsheet-guide" className="block text-sm text-background-200 hover:text-accent-400 transition-colors">Beginner Guide</Link>
              <Link to="/kakobuy-spreadsheet" className="block text-sm text-background-200 hover:text-accent-400 transition-colors">Spreadsheet Resource</Link>
              <Link to="/kakobuy-spreadsheet-how-to-use" className="block text-sm text-background-200 hover:text-accent-400 transition-colors">How To Use</Link>
              <Link to="/safety" className="block text-sm text-background-200 hover:text-accent-400 transition-colors">Safety Guide</Link>
              <Link to="/about" className="block text-sm text-background-200 hover:text-accent-400 transition-colors">About Us</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-accent-400 hover:text-accent-300 transition-colors font-medium">Visit Kakobuy Sheet →</a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800/50">
        <div className="w-full px-4 md:px-6 py-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-400">
              &copy; 2026 <Link to="/" className="text-background-200 hover:text-accent-400 transition-colors">kakobuyfinds.bond</Link>. All rights reserved.
            </p>
            <p className="text-xs text-background-500">
              This site provides informational resources only. External links open in new tabs.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}